import { http as axios } from "@/general/utils/http";
import {
  GiveThanksPointRequest,
  GiveThanksPoints,
  ListResponse,
  ThankPointMessage,
  ThankPointSearchByUser,
  ThanksPoint,
  ThanksPointMessageHasRead,
  ThanksPointUserSelect,
  ThanksMessageThreadResponse,
  ThanksPointUser
} from "../store/models";

/**
 * Thanks point api
 */
export default class ThanksPointApi {
  /**
   * Get thanks point list
   * @param search
   *
   * @return Promise|Error
   */
  public static async getThankPointList(
    search?: string, currentPage = 1
  ) {
    const response: any = await axios.get(
      `api/thanks-point`,
      {
        params: {
          search,
          currentPage
        }
      }
    );
    return response;
  }

  /**
   * Search thanks point by user
   *
   * @param page
   * @param pageSize
   * @param search
   * @returns Promise|Error
   */
  public static async searchThanksPointByUser(
    page: number | undefined,
    pageSize: number | undefined,
    search: string | undefined
  ) {
    const response: ListResponse<ThankPointSearchByUser> = await axios.get(
      `api/search_thanks_giving_by_user`,
      {
        params: {
          page,
          page_size: pageSize,
          search
        }
      }
    );
    return response;
  }

  /**
   * get thanks point message list
   *
   * @param page
   * @param pageSize
   * @param thanks_giving_id
   * @returns Promise|Error
   */
  public static async getThanksPointMessageList(
    page: number,
    page_size: number | undefined,
    thanks_giving_id: number
  ) {
    const response: ListResponse<ThankPointMessage> = await axios.get(
      `api/thanks_giving_message/${thanks_giving_id}`,
      {
        params: {
          page,
          page_size
        }
      }
    );
    return response;
  }

  /**
   *  post thanks point message
   *
   * @param to_user_id
   * @param message
   * @param parent
   * @returns Promise|Error
   */
  public static async postThanksPointMessage(
    to_user_id: number,
    message: string | undefined
  ) {
    const response: ThankPointMessage = await axios.post(
      `api/thanks_giving_message`,
      {
        to_user_id,
        message
      }
    );
    return response;
  }

  /**
   * get thanks message threads
   *
   * @param userId
   * @returns Promise|Error
   */
  public static async getThanksThreadMessages(
    userId: number,
    startRow?: number,
    endRow?: number
  ) {
    const response: ThanksMessageThreadResponse =
      await axios.get(
        `api/thanks_thread_messages/${userId}`,
        {
          params: {
            startRow,
            endRow
          }
        }
      );
    return response;
  }

    /**
   *  patch thanks point message
   *
   * @param thanks_giving_id
   * @param ordering
   * @param search
   * @param has_read
   * @returns Promise|Error
   */
  public static async patchThanksPointMessage(
    thanks_giving_id: number,
    ordering: string | undefined,
    search: string | undefined,
    has_read: boolean
  ) {
    const response: ThanksPointMessageHasRead = await axios.patch(
      `api/thanks_giving_message`,
      {
        thanks_giving_id,
        ordering,
        search,
        has_read
      }
    );
    return response;
  }

  /**
   * get thanks point user selection
   *
   * @param search
   * @returns Promise|Error
   */
  public static async getThanksPointUserSelection(search: string | undefined) {
    const response: ListResponse<ThanksPointUserSelect> = await axios.get(
      `api/customUser`,
      {
        params: {
          search
        }
      }
    );
    return response;
  }

  /**
   * get thanks point user info
   *
   * @param userIds
   * @returns Promise<ThanksPointUser[]>
   */
  public static async getThanksUsersInfo(
    userIds: number[]
  ): Promise<ListResponse<ThanksPointUser>> {
	const params = new URLSearchParams();
	userIds.forEach(id => {
	  params.append("userIds", String(id));
	});
    const response: ListResponse<ThanksPointUser> = await axios.get(`api/thanks-users-info?${params.toString()}`);
    return response;
  }

  	/**
	   * get thanks point partneruser selection
	   *
	   * @param partnerUserId
	   * @returns Promise|Error
	   */
	public static async getThanksPointUserSelectionByUserId(partnerUserId: number) {
		const response: ListResponse<ThanksPointUserSelect> = await axios.get(
			`api/customUser`,
			{
				params: {
					partnerUserId
				}
			}
		);
		return response;
	}

  /**
   * get give thanks point
   *
   * @returns Promise|Error
   */
  public static async getGiveThanksPoints() {
    const response: GiveThanksPoints = await axios.get(`api/thanks_point_giving_type`);
    return response;
  }

  /**
   *  post thanks point
   *
   * @param payload
   * @returns Promise|Error
   */
  public static async postThanksPoint(
    payload: GiveThanksPointRequest
  ): Promise<any> {
    return await axios.post(
      `api/thanks-point`,
      payload
    );
  }
}
